"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseFormatMoney = exports.createFormatMoney = void 0;
const currency_js_1 = __importDefault(require("currency.js"));
const react_1 = require("react");
const context_1 = require("../context/context");
const curry_1 = require("../utils/curry");
const money_defaults_1 = require("../utils/money-defaults");
const defaultPatterns = {
    pattern: "#\xa0!",
    negativePattern: "-#\xa0!",
};
const noSymbolPatterns = {
    pattern: "#",
    negativePattern: "-#",
};
function createFormatMoney(localizeConfigs) {
    return (locale, money, options) => {
        var _a, _b, _c;
        const precision = (_a = options === null || options === void 0 ? void 0 : options.precision) !== null && _a !== void 0 ? _a : 0;
        const symbol = money.currency;
        const config = localizeConfigs[locale].currency;
        const specialCasesConfig = config.specialCases;
        const currentPatterns = (_c = (_b = (specialCasesConfig !== null && specialCasesConfig !== void 0 ? specialCasesConfig : {})[money.currency]) !== null && _b !== void 0 ? _b : money_defaults_1.MoneyDefaults[money.currency]) !== null && _c !== void 0 ? _c : defaultPatterns;
        const patterns = (options === null || options === void 0 ? void 0 : options.hideSymbol)
            ? noSymbolPatterns
            : !(options === null || options === void 0 ? void 0 : options.preferIsoCode)
                ? currentPatterns
                : defaultPatterns;
        const formatOptions = {
            ...patterns,
            decimal: config.decimalSeparator,
            separator: config.thousandsSeparator,
            precision,
            symbol,
        };
        return (0, currency_js_1.default)(money.amount, { precision }).format(formatOptions);
    };
}
exports.createFormatMoney = createFormatMoney;
function createUseFormatMoney(localizeConfigs) {
    return () => {
        const locale = (0, context_1._useLocalizeContext)();
        return (0, react_1.useMemo)(() => (0, curry_1._curry)(createFormatMoney(localizeConfigs))(locale), [locale]);
    };
}
exports.createUseFormatMoney = createUseFormatMoney;
